<svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
<circle cx="11" cy="11" r="9" fill="white"/>
<circle cx="11" cy="11" r="10" stroke="#C04184" stroke-opacity="0.4" stroke-width="2"/>
<path d="M7.55005 14.4498L14.45 7.5498" stroke="#C04184" stroke-opacity="0.4" stroke-width="2" stroke-miterlimit="10" stroke-linecap="square"/>
<path d="M7.55005 7.5498L14.45 14.4498" stroke="#C04184" stroke-opacity="0.4" stroke-width="2" stroke-miterlimit="10" stroke-linecap="square"/>
</svg> 
 